import type { FieldError } from '@servicetim/shared';

/** Compact list of server field errors for one row/section (paths stripped of a prefix). */
export function InlineErrors({
  errors,
  prefix,
}: {
  errors: readonly FieldError[];
  prefix?: string;
}) {
  if (errors.length === 0) return null;
  return (
    <ul role="alert" className="space-y-0.5 text-red-600 dark:text-red-400 text-xs">
      {errors.map((e) => {
        const shown = prefix && e.path.startsWith(prefix) ? e.path.slice(prefix.length) : e.path;
        const rel = shown.replace(/^\./, '');
        return (
          <li key={`${e.path}:${e.message}`}>
            {rel ? <code className="font-mono">{rel}</code> : null}
            {rel ? ' ' : ''}
            {e.message}
          </li>
        );
      })}
    </ul>
  );
}
